export default __webpack_public_path__ + "static/media/VCOM.2f6340bb.jpeg";